import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/authSlice";

import authApis from "src/api/auth";

import { common } from "src/types/index";
import { constants } from "src/constants/common";

// login patient saga
const LoginPatientSaga = function* LoginPatientSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      authApis.loginPatient,
      payload
    );

    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.loginPatientSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.loginPatientError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// get patient details saga
const GetPatientDetailsSaga = function* GetPatientDetailsSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      authApis.getPatientDetails,
      payload
    );

    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.getPatientDetailsSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.getPatientDetailsError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// update profile saga
const UpdateProfileSaga = function* UpdateProfileSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      authApis.updateProfile,
      payload
    );

    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.updateProfileSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.updateProfileError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

export default function* authSaga() {
  yield all([
    takeEvery(actions.loginPatientRequest, LoginPatientSaga),
    takeEvery(actions.getPatientDetailsRequest, GetPatientDetailsSaga),
    takeEvery(actions.updateProfileRequest, UpdateProfileSaga),
  ]);
}
